<script setup lang="ts">
/**
 * Sits behind a LemonSqueezy checkout iframe: the checkout takes a few seconds
 * to draw, and until it does the frame would be an empty white box that reads
 * as broken. The checkout's own page covers this as soon as it paints.
 */
const { t } = useI18n()
</script>

<template>
  <div class="pointer-events-none absolute inset-0 flex items-center justify-center gap-3 text-muted dark:text-gray-400" aria-hidden="true">
    <span class="inline-block size-5 animate-spin rounded-full border-2 border-current border-t-transparent" />
    <span class="text-sm font-semibold">{{ t('premium.checkoutLoading') }}</span>
  </div>
</template>
